import {DISCORD_DEVICE_TYPES, type ImageURL, LobbyImage} from '@colonist/types'
import {type GameClientUserState, type VictoryPointTypes} from '@colonist/game-base-types'
import {type CardEnum, type NestedReadonly, type PlayerColor, type PlayerState} from '@colonist/game-states'
import {CardValidatorOrdered} from './card/CardValidatorOrdered.ts'

export class PlayerValidator {
    state: NestedReadonly<PlayerState>
    userState: NestedReadonly<GameClientUserState>
    readonly resourceCards: CardValidatorOrdered

    constructor(newPlayerState: NestedReadonly<PlayerState>, userState: NestedReadonly<GameClientUserState>) {
        this.state = newPlayerState
        this.userState = userState
        this.resourceCards = new CardValidatorOrdered(this.state.resourceCards)
    }

    get color(): PlayerColor {
        return this.state.color
    }

    get displayIcon(): LobbyImage {
        if(!this.isActiveHumanSession) return LobbyImage.Bot

        return this.userState.databaseIcon
    }

    get profilePictureUrl(): ImageURL | undefined {
        return this.userState.profilePictureUrl
    }

    get username(): string {
        return this.userState.username
    }

    get isConnected(): boolean {
        return this.state.isConnected
    }

    get isUser(): boolean {
        return this.userState.userId != undefined
    }

    get isActiveHumanSession(): boolean {
        if(!this.isUser) return false
        if(!this.isConnected) return false

        return true
    }

    get cardDiscardLimit(): number {
        return this.state.cardDiscardLimit
    }

    get victoryPointsState(): {[key in VictoryPointTypes]?: number} {
        return this.state.victoryPointsState
    }

    get bankTradeRatiosState(): {[key in CardEnum]?: number} {
        return this.state.bankTradeRatiosState
    }

    get isLocalDiscordPlayer(): boolean {
        return this.profilePictureUrl != undefined
    }

    get isPlayingOnDiscord(): boolean {
        if(this.userState.deviceType == undefined) return false
        return DISCORD_DEVICE_TYPES.includes(this.userState.deviceType)
    }

    hasResourceCardsInHand(cardEnums: CardEnum[]): boolean {
        return this.resourceCards.hasCardsInInventory(cardEnums)
    }
}
